import { Color, DisplayMode, Engine, FadeInOut, Flags } from "excalibur";
import { loader } from "./resources";
import { MyLevel } from "./level";
import { gameState } from "./gameState";

// Goal is to keep main.ts small and just enough to configure the engine

// Force Canvas 2D renderer to avoid WebGL context loss issues
Flags.useCanvasGraphicsContext();

// Load saved gold and wave before starting the engine
try { gameState.loadFromStorage(); } catch {}

const game = new Engine({
  width: 900, // Logical width and height in game pixels
  height: 900,
  displayMode: DisplayMode.FitScreenAndFill, // Display mode tells excalibur how to fill the window
  pixelArt: true, // pixelArt will turn on the correct settings to render pixel art without jaggies or shimmering artifacts
  scenes: {
    start: MyLevel
  },
  // physics: {
  //   solver: SolverStrategy.Realistic,
  //   substep: 5 // Sub step the physics simulation for more robust simulations
  // },
  // fixedUpdateTimestep: 16 // Turn on fixed update timestep when consistent physic simulation is important
  suppressPlayButton: true, // Set to true to remove the play button on load
});

game.start('start', { // name of the start scene 'start'
  loader, // Optional loader (but needed for loading images/sounds)
  inTransition: new FadeInOut({ // Optional in transition
    duration: 1000,
    direction: 'in',
    color: Color.ExcaliburBlue
  })
}).then(() => {
  // Apply saved timescale now that engine exists
  try { game.timescale = Math.max(1, Math.min(5, gameState.timescale)); } catch {}
  // Initialize DOM-based UI overlay
  import('./domUi.js').then(({ initDomUi }) => initDomUi(game));
});